var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.floatLeft ? 'back-left' : 'default'},[_c('el-button',{attrs:{"size":"small","type":_vm.btnType},on:{"click":_vm.back}},[_vm._v("返回")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }